import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import css2 from './shared.module.scss';
import Button from 'src/components/atoms/Button';
import { nextStep, previousStep, setBusinessInfo } from 'src/slices/signup';
import { updateBusinessInfo } from 'src/slices/info';
import HoursSelector from 'src/components/organisms/HoursSelector';
import dayjs from 'dayjs';

export default function StoreHours() {
  const dispatch = useDispatch();
  const { user, businessInfo } = useSelector((state) => state.signup);
  const { token } = useSelector((state) => state.signup);

  const [storeInfo, setStoreInfo] = useState({
    hours: [],
  });

  useEffect(() => {
    setStoreInfo({
      ...storeInfo,
      hours: Array.isArray(businessInfo.hours) ? businessInfo.hours : template,
    });
  }, [businessInfo]);

  const handleNext = () => {
    const data = {
      hours: JSON.stringify(storeInfo.hours),
    };

    dispatch(setBusinessInfo(storeInfo));

    dispatch(
      updateBusinessInfo({
        data,
        fieldset: 'business',
        signupToken: token,
        merchantId: user.id,
      }),
    )
      .unwrap()
      .then(() => dispatch(nextStep()));
  };
  const handleBack = () => {
    dispatch(previousStep());
  };

  const updateIsClosed = (index) => {
    setStoreInfo({
      ...storeInfo,
      hours: storeInfo.hours.map((day, i) =>
        index === i
          ? {
              ...day,
              isClosed: !day.isClosed,
            }
          : day,
      ),
    });
  };

  const updateTime = (time, index, type) => {
    setStoreInfo({
      ...storeInfo,
      hours: storeInfo.hours.map((day, i) =>
        index === i
          ? {
              ...day,
              [type]: dayjs(time, 'HH:mm').format('HH:mm').toString().toUpperCase(),
            }
          : day,
      ),
    });
  };

  // New code, by Shahriar
  const addSubDay = (index, day) => {
    let newHours = [...storeInfo.hours];
    newHours.splice(index + 1, 0, {
      day: day,
      openTime: '00:00 AM',
      closeTime: '00:00 AM',
      isClosed: false,
      isSub: 'true',
    });
    setStoreInfo({
      ...storeInfo,
      hours: newHours,
    });
  };

  const removeSubDay = (index) => {
    let newHours = [...storeInfo.hours];
    newHours.splice(index, 1);
    setStoreInfo({
      ...storeInfo,
      hours: newHours,
    });
  };

  const template = [
    {
      day: 'Sunday',
      openTime: '07:00 AM',
      closeTime: '23:00 PM',
      isClosed: false,
    },
    {
      day: 'Monday',
      openTime: '07:00 AM',
      closeTime: '23:00 PM',
      isClosed: false,
    },
    {
      day: 'Tuesday',
      openTime: '07:00 AM',
      closeTime: '23:00 PM',
      isClosed: false,
    },
    {
      day: 'Wednesday',
      openTime: '07:00 AM',
      closeTime: '23:00 PM',
      isClosed: false,
    },
    {
      day: 'Thursday',
      openTime: '07:00 AM',
      closeTime: '23:00 PM',
      isClosed: false,
    },
    {
      day: 'Friday',
      openTime: '07:00 AM',
      closeTime: '23:00 PM',
      isClosed: false,
    },
    {
      day: 'Saturday',
      openTime: '07:00 AM',
      closeTime: '23:00 PM',
      isClosed: false,
    },
  ];

  return (
    <>
      <HoursSelector
        hours={storeInfo.hours}
        updateDay={updateIsClosed}
        updateHour={updateTime}
        addSubDay={(i, d) => addSubDay(i, d)}
        removeSubDay={(i) => removeSubDay(i)}
        userCanUpdate={true}
      />

      <div className={css2['buttons']}>
        {
          <Button
            label="Back"
            variant="tertiary"
            color="white"
            iconLeft="fa fa-chevron-left"
            action={handleBack}
          />
        }
        <Button
          label="Continue"
          variant="primary"
          color="white"
          iconRight="fa fa-chevron-right"
          action={handleNext}
        />
      </div>
    </>
  );
}
